/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListDoorReportsQueryResponse,
  ListDoorReportsQueryParams,
} from '../types/ListDoorReports'

function getListDoorReportsUrl() {
  const res = { method: 'GET', url: `/api/v1/reports/doors/` as const }
  return res
}

/**
 * @description Paginated list of door reports (doors joined with CRM data). Raw-SQL view backed by DoorsWithCRMReportsRequestParams (a Pydantic model, not a DjangoFilterBackend filterset), so every query param is listed explicitly below -- drf-spectacular cannot auto-introspect it.
 * @summary List door reports
 * {@link /api/v1/reports/doors/}
 */
export async function listDoorReports(
  params?: ListDoorReportsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListDoorReportsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListDoorReportsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
